import React from "react";
import Sidebar from "./Sidebar";
import { useLocation } from "react-router";

interface IProps {
  routes: any[];
  collapsed: boolean;
}

const SidebarContainer = (props: IProps) => {
  const { pathname } = useLocation();

  return <Sidebar {...props} pathName={pathname} />;
};

export default SidebarContainer;
